export const NAVER_ACCOUNT_ID = "2543894";

// custom001 is reserved for "Download QR code" — do not reuse it elsewhere.
const DOWNLOAD_QR_CONVERSION_TYPE = "custom001";

function trackNaverConversion(conv: Record<string, unknown>) {
  if (!NAVER_ACCOUNT_ID || !window.wcs) return;

  window.wcs_add = window.wcs_add || {};
  window.wcs_add.wa = NAVER_ACCOUNT_ID;
  window.wcs.trans(conv);
}

export function trackNaverDownloadQrConversion(format: string) {
  trackNaverConversion({
    type: DOWNLOAD_QR_CONVERSION_TYPE,
    id: `${format}_${Date.now()}`,
  });
}

interface INaverSubscriptionConversion {
  isPremium: boolean;
  isYearly: boolean;
  price: number | null;
  quantity?: number;
}

export function trackNaverSubscriptionConversion({
  isPremium,
  isYearly,
  price,
  quantity = 1,
}: INaverSubscriptionConversion) {
  if (price === null || !Number.isFinite(price) || price <= 0) return;

  // Same ids/names as the main site (me-qr), so purchases from both group
  // under the same items in Naver reports
  const itemId = `${isPremium ? "premium" : "lite"}_${isYearly ? "year" : "month"}`;
  const itemName = `${isPremium ? "Premium" : "Lite"} ${isYearly ? "Yearly" : "Monthly"}`;
  const amount = Number(price.toFixed(2));

  trackNaverConversion({
    type: "purchase",
    id: `${itemId}_${Date.now()}`,
    items: [
      {
        id: itemId,
        name: itemName,
        category: "subscription",
        quantity,
        payAmount: amount,
      },
    ],
    value: String(amount),
  });
}
